module.exports = __webpack_public_path__ + "static/media/teygja_bakaefing.c31edeed.png";